import { settings } from '../settings';

// (ReferenceError: regeneratorRuntime is not defined)
import 'regenerator-runtime/runtime'; // workaround

export const userAuthed = () => fetch(`${settings.API_HOST}/mobile_api/json/login/`, {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
});

export const userLogin = data => fetch(`${settings.API_HOST}/mobile_api/json/login/`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include',
  body: JSON.stringify(data),
});

export const checkAuthentication = async () => await (await userAuthed()).json();

export const userLogout = final_url => `${settings.API_HOST}/mobile_api/json/logout/${final_url 
  ? `?final_url=${window.location.href}` : ''}`;
